export default "__VITE_ASSET__78fa9b50__"